/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Button } from 'reactstrap';
import { ToolbarComponentCommonProps } from '..';
import { QUESTION } from '../../../../constants/terminology';

export const FilterQuestionsToggle = (props: ToolbarComponentCommonProps) => {
  const { toggleFilters } = props;

  return (
    <div>
      <Button color='link' size='sm' onClick={() => toggleFilters()} className='filter-questions-btn'>
        Filter {QUESTION.PLURAL}
      </Button>
    </div >
  );
}
